// extracted by mini-css-extract-plugin
module.exports = {"terms":"wap_terms__xIi32","main":"wap_main__RHw0J"};